export const USAGE_MANUAL_LANGUAGES = [
    { id: 'en', name: 'English', code: 'EN', flagUrl: '/assets/images/flags/us-flag.svg' },
    { id: 'nl', name: 'Nederlands', code: 'NL', flagUrl: '/assets/images/flags/nl-flag.svg' },
    { id: 'de', name: 'Deutsch', code: 'DE', flagUrl: '/assets/images/flags/de-flag.svg' }
];
export const getDocumentForLanguage = (version, language) => version.documents.find((d) => d.language.toLowerCase() === language.toLowerCase());
